<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-fussion">
  <p style="font-size: 16px; color: white">Loading...</p>
</ngx-spinner>

<div *ngIf="isUserLoggedIn">
  <!-- <app-header
    *ngIf="router.url.split('/')[1]!='confirm-email' && router.url.split('/')[1]!='create-password' && router.url.split('/')[1]!='forgot-password' && router.url.split('/')[1]!='login' && router.url.split('/')[1]!='analytics' && router.url.split('/')[1]!='all-analytics' && router.url.split('/')[1]!='view-details' && router.url.split('/')[1]!='data-products' && router.url.split('/')[1]!='app'"></app-header> -->

 <app-header-v2
    *ngIf="router.url.split('/')[1]!='confirm-email' && router.url.split('/')[1]!='create-password' && router.url.split('/')[1]!='forgot-password'&& router.url.split('/')[1]!='login'"></app-header-v2>

  <div class="container" [class.noContainer]="isAnalyticsHomePageFn()">
    <router-outlet></router-outlet>
  </div>

  <!--<app-footer
    *ngIf="router.url.split('/')[1]!='confirm-email' && router.url.split('/')[1]!='create-password'&&router.url.split('/')[1]!='forgot-password' && router.url.split('/')[1]!='login'"></app-footer>-->

  <app-footer></app-footer>
</div>

<app-alert [message]="errMsg" *ngIf="showErrorMessageWithPopup" (close)="onCloseHandler()"></app-alert>